import { useState, useEffect, useRef } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';

export function useClient(clientId) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(!!clientId);
  const [error, setError] = useState(null);
  const prevClientIdRef = useRef(undefined);

  useEffect(() => {
    if (!clientId) {
      setClient(null);
      setLoading(false);
      setError(null);
      prevClientIdRef.current = undefined;
      return;
    }

    const idChanged = prevClientIdRef.current !== clientId;
    prevClientIdRef.current = clientId;

    // Only enter full loading when the subscribed client id changes — avoids flashing
    // back to spinner on Strict Mode re-mount or unrelated parent re-renders.
    if (idChanged) {
      setLoading(true);
      setError(null);
    }

    const db = firebase.firestore();
    const ref = db.collection('clients').doc(clientId);

    const unsubscribe = ref.onSnapshot(
      (snapshot) => {
        if (snapshot.exists) {
          setClient({ id: snapshot.id, ...snapshot.data() });
        } else {
          setClient(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('client snapshot error:', err);
        setError(err);
        setClient(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [clientId]);

  return [loading, client, error];
}

